import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  InputSignal
} from '@angular/core';
import {
  VALIDATION_ERROR_MESSAGES,
  ValidationErrorMessage
} from './validation-error-messages.token';
import { KeyValuePipe } from '@angular/common';
import { ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-control-error',
  imports: [KeyValuePipe],
  templateUrl: './control-error.component.html',
  styleUrl: './control-error.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ControlErrorComponent {
  protected errorMessages: ValidationErrorMessage = inject(
    VALIDATION_ERROR_MESSAGES
  );

  errors: InputSignal<ValidationErrors | null> = input<ValidationErrors | null>(
    null
  );
}
